"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useState } from "react";
import UserIcon from "../../icons/user.js";
import { makeStyles } from "../../theming/index.js";
import AvatarBase from "../avatar-base/index.js";
function fontSize(size, theme) {
    switch (size) {
        case "small": {
            return theme.typography.small.fontSize;
        }
        case "medium": {
            return theme.typography.body.fontSize;
        }
        case "large": {
            return theme.size(20);
        }
    }
}
const useStyles = makeStyles()((theme, { error, image, size }) => ({
    avatar: {
        border: image && !error ? 0 : undefined,
    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: "100%",
    },
    label: {
        fontWeight: theme.typography.fontWeights.semiBold,
        fontSize: fontSize(size, theme),
        textAlign: "center",
        textTransform: "uppercase",
    },
}));
function getInitials(name) {
    if (!name) {
        return "?";
    }
    const [firstName, lastName] = name.split(" ");
    return firstName && lastName ? `${firstName.charAt(0)}${lastName.charAt(0)}` : firstName.charAt(0);
}
export const Avatar = React.forwardRef(function Avatar(_a, ref) {
    var { name, className, color = name ? "primary" : "gray", size = "medium", src, srcSet, variant = "faded" } = _a, props = __rest(_a, ["name", "className", "color", "size", "src", "srcSet", "variant"]);
    const [error, setError] = useState(false);
    const img = src || srcSet;
    const { classes, cx } = useStyles({ error, image: !!img, size });
    const initials = getInitials(name || "");
    const handleError = useCallback(() => {
        setError(true);
    }, []);
    return (_jsx(AvatarBase, Object.assign({ ref: ref, className: cx(classes.avatar, className), color: error ? "gray" : color, "data-component": "avatar", size: size, variant: variant }, props, { children: img && !error ? (_jsx("img", { alt: name || "", className: classes.image, src: src, srcSet: srcSet, onError: handleError })) : name ? (_jsx("div", { "aria-label": name, className: classes.label, children: initials })) : (_jsx(UserIcon, {})) })));
});
export default Avatar;
//# sourceMappingURL=avatar.js.map